import { Outlet } from "react-router-dom";
import React, { useState } from "react";

function Survey() {
  const [survey, setSurvey] = useState({});
  const [isEdit, setIsEdit] = useState({ disabled: false, edit: false });
  return <Outlet context={{ survey, setSurvey, setIsEdit, isEdit }} />;
}
export default Survey;
